import firebase from "firebase/compat/app"
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/messaging';
//import { getMessaging } from "firebase/messaging";
import { getMessaging } from "firebase/messaging";
import { getFunctions, httpsCallable } from "firebase/functions";
 
const firebaseConfig = {
  apiKey: "AIzaSyDG3lxf4Mq5pNeHvfDb43UaP8ggKprVzn0",
  authDomain: "craftiqapp.firebaseapp.com",
  databaseURL: "https://craftiqapp-default-rtdb.firebaseio.com",
  projectId: "craftiqapp",
  storageBucket: "craftiqapp.appspot.com",
  messagingSenderId: "104093682414",
  appId: "1:104093682414:web:8df22214f1635cfb6841ff",
  measurementId: "G-MYBYVZQ21K"
};
const firebaseApp = firebase.initializeApp(firebaseConfig)
//const messaging = firebase.messaging();
const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const frbase = firebase
const messaging = getMessaging(firebaseApp);
const functions = getFunctions();
 
export { auth, db, frbase, storage,messaging, functions, httpsCallable };
 


// import firebase from "firebase/compat/app"
// import 'firebase/compat/auth';
// import 'firebase/compat/firestore';
// import 'firebase/compat/storage';
// import 'firebase/compat/messaging';
// import { getMessaging } from "firebase/messaging";
// import { getFunctions, httpsCallable } from "firebase/functions";
 
// const firebaseConfig = {
//   apiKey: "AIzaSyDG3lxf4Mq5pNeHvfDb43UaP8ggKprVzn0",
//   authDomain: "craftiqapp.firebaseapp.com",
//   databaseURL: "https://craftiqapp-default-rtdb.firebaseio.com",
//   projectId: "craftiqapp",
//   storageBucket: "craftiqapp.appspot.com",
//   messagingSenderId: "104093682414",
//   appId: "1:104093682414:web:8df22214f1635cfb6841ff",
//   measurementId: "G-MYBYVZQ21K"
// };
// const firebaseApp = firebase.initializeApp(firebaseConfig)
// const db = firebaseApp.firestore();
// const auth = firebase.auth();
// const storage = firebase.storage();
// const frbase = firebase
// const messaging = getMessaging(firebaseApp);

// // FIX: Pass the firebaseApp and region to getFunctions
// const functions = getFunctions(firebaseApp, 'us-central1');
 
// export { auth, db, frbase, storage, messaging, functions, httpsCallable };